// @flow
import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/styles';

import UserIcon from '../Icons/UserIcon';

import { getAvaName, getDisplayName } from '../../utils/user';
import { getPlanType } from '../../utils/status';

const useStyles = makeStyles(theme => ({
  details: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    paddingTop: 18,
    paddingRight: 24,
    paddingBottom: 8,
    paddingLeft: 24,
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 16,
    overflow: 'hidden',
    '& > :not(:first-child)': {
      marginBottom: 4,
    },
  },
  text: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  name: {
    color: theme.palette.type === 'light' ? theme.palette.ava.dark1 : theme.palette.ava.white,
    fontSize: 20,
    lineHeight: '26px',
  },
  avaName: {
    color: theme.palette.type === 'light' ? theme.palette.ava.grey5 : theme.palette.ava.text.dark2,
    fontSize: 16,
    lineHeight: '20.8px',
  },
  plan: {
    fontSize: 14,
    lineHeight: '18.2px',
  },
  blue: {
    color: theme.palette.ava.blue2,
  },
}));

interface Props {
  user: Object;
  subscription: Object;
}

const ProfileDetails = ({ user, subscription }: Props) => {
  const classes = useStyles();

  const subscriptionLabel = getPlanType(subscription);

  return (
    <section className={classes.details}>
      <UserIcon width={80} height={80} />
      <div className={classes.info}>
        <span className={classnames(classes.text, classes.name)}>{getDisplayName(user)}</span>
        <span className={classnames(classes.text, classes.avaName)}>
          <span className={classes.blue}>&</span>
          {getAvaName(user)}
        </span>
        <span className={classnames(classes.text, classes.plan, classes.blue)}>{subscriptionLabel} Plan</span>
      </div>
    </section>
  );
};

const mapStateToProps = ({ scribeSession: { captioner, subscription } }) => ({
  user: captioner,
  subscription,
});

export default connect(mapStateToProps)(ProfileDetails);
